module.exports = __webpack_public_path__ + "img/dice-d12.c6bdc6d2.svg";